import { render, staticRenderFns } from "./AscPlotAxesTabWrapper.vue?vue&type=template&id=ca287548&"
import script from "./AscPlotAxesTabWrapper.vue?vue&type=script&lang=js&"
export * from "./AscPlotAxesTabWrapper.vue?vue&type=script&lang=js&"
import style0 from "./AscPlotAxesTabWrapper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VDivider,VRow})
